import { Application } from '@/models/applications/application';

export default class ApplicationService {
    private application: Application | null = null;

    public getCurrentApplication(): Application {
        if (this.application) {
            return this.application;
        }

        this.application = new Application(JSON.parse(process.env.VUE_APP_APPLICATION_DETAILS!));

        return this.application;
    }
}

export const appService = new ApplicationService();
